import React, {useState, useEffect} from 'react';
import './checkboxlist.scss'

const CheckBoxList = () => {
	const [CheckboxData, setCheckboxData] = useState ([]);
	
	const getAllCheckboxData = async () => {
		try {
			const response = await fetch ('/data/uielements.json');
			if (!response.ok) {
				throw new Error ('Failed to fetch data');
			}
			const data = await response.json ();
			
			const filterCheckboxData = data.UIElements?.filter ((uicode) => uicode.UIElementId === "UIElemetCheckbox");
			
			
			setCheckboxData (filterCheckboxData || []);
		} catch (err) {
			console.error ('Error fetching checkbox data:', err);
		}
	}
	
	useEffect (() => {
		getAllCheckboxData ();
	}, [])
	
	const handleDownload = (file) => {
		const link = document.createElement ('a');
		link.href = file;
		link.download = file.split ('/').pop (); // Extract file name from path
		document.body.appendChild (link);
		link.click ();
		document.body.removeChild (link);
	};
	
	const handlePayAmount = (filePay) =>{
		const link = document.createElement ('a');
		link.href = filePay;
		link.download = filePay.split ('/').pop ();;
		document.body.appendChild (link);
		link.click ();
		document.body.removeChild (link);
	}
	
	return (
		<div className="mainCheckBoxList">
			<div className="subCheckBoxList">
				{
					CheckboxData.length === 0 ? (
						<p>No Data</p>
					) : (
						CheckboxData.map ((item, index) => (
							<div className="CheckBoxList" key={index}>
								<div className="CheckBoxListUIElements-image-box">
									<img src={item.VideoGif} alt=""/>
								</div>
								
								<div className="CheckBoxListInfo">
									<div className="title">{item.title}</div>
									<p>{item.Developer}</p>
									<div className="mainDownloadBtn">
										{item.PayAmount === "Yes" ? (
												<>
													<button onClick={() => handlePayAmount(item.PayAmountUrl)}>Pay</button>
												</>
											) : (
												<button className='DownloadBtn' onClick={() => handleDownload (item.ZipFile)}>Download</button>
											)
										}
										
									</div>
								</div>
							</div>
						)))
				}
			</div>
		</div>
	)
}

export default CheckBoxList